import { useEffect, useRef } from 'react';
import { BiFilterAlt } from 'react-icons/bi';
import { IoCloseSharp } from 'react-icons/io5';
import { useSelector } from 'react-redux';

import { RootState } from '../../../redux/store';

import { Category, FilterValue } from './QuestionsLeftPane';

type FiltersPopupType = {
  setShowFilters: (val: boolean) => void;
  showFilters: boolean;
  toggleFilter: (val1: Category, val2: FilterValue) => void;
};

const FiltersPopUp = ({
  setShowFilters,
  showFilters,
  toggleFilter
}: FiltersPopupType) => {
  const { filters } = useSelector(
    (state: RootState) => state.root.startFulltest
  );

  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setShowFilters(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowFilters]);

  return (
    <div
      ref={popupRef}
      style={{ boxShadow: '0px 0px 10px 5px #20202026' }}
      className='absolute left-[70%] top-0 z-10 w-[282px] rounded-lg border bg-white p-4 shadow-lg'
    >
      <div className='mb-4 flex items-center justify-between'>
        <div className='text-appPrimaryColor flex items-center gap-2'>
          <button
            onClick={() => setShowFilters(!showFilters)}
            className=' rounded hover:bg-gray-100'
          >
            <BiFilterAlt size={24} className='font-medium' />
          </button>
          <p className='text-[21px]'>Filters</p>
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className='rounded p-1 hover:bg-gray-100'
        >
          <IoCloseSharp
            size={24}
            className='text-appPrimaryColor font-medium'
          />
        </button>
      </div>
      <div className='space-y-4 text-[#283044]'>
        <div className='border-b border-[#E1E1E1] pb-4'>
          <h3 className='mb-2 text-xs font-semibold uppercase text-[#646464]'>
            Section
          </h3>
          <label className='custom-checkbox mb-5'>
            Reading & Writing Section{' '}
            <input
              type='checkbox'
              checked={filters.section.readingWriting}
              onChange={() => toggleFilter('section', 'readingWriting')}
            />
            <span className='filterCheckmark' />
          </label>
          <label className='custom-checkbox mb-2'>
            Math{' '}
            <input
              type='checkbox'
              checked={filters.section.math}
              onChange={() => toggleFilter('section', 'math')}
            />
            <span className='filterCheckmark' />
          </label>
        </div>

        <div className='border-b border-[#E1E1E1] pb-4'>
          <h3 className='mb-2 text-xs font-semibold uppercase text-[#646464]'>
            Module {''}
          </h3>
          <label className='custom-checkbox mb-5 flex items-center gap-2'>
            <input
              type='checkbox'
              checked={filters.module.module1}
              onChange={() => toggleFilter('module', 'module1')}
            />{' '}
            Module 1 <span className='filterCheckmark' />
          </label>

          <label className='custom-checkbox flex items-center gap-2'>
            <input
              type='checkbox'
              checked={filters.module.module2}
              onChange={() => toggleFilter('module', 'module2')}
            />{' '}
            Module 2 <span className='filterCheckmark' />
          </label>
        </div>

        <div>
          <h3 className='mb-2 text-xs font-semibold uppercase text-[#646464]'>
            Answer Type{' '}
          </h3>
          <label className='custom-checkbox mb-5 flex items-center gap-2'>
            <input
              type='checkbox'
              checked={filters.answerType.correct}
              onChange={() => toggleFilter('answerType', 'correct')}
            />{' '}
            Correct <span className='filterCheckmark' />
          </label>
          <label className='custom-checkbox mb-5 flex items-center gap-2'>
            <input
              type='checkbox'
              checked={filters.answerType.incorrect}
              onChange={() => toggleFilter('answerType', 'incorrect')}
            />{' '}
            Incorrect <span className='filterCheckmark' />
          </label>
          <label className='custom-checkbox flex items-center gap-2'>
            <input
              type='checkbox'
              checked={filters.answerType.omitted}
              onChange={() => toggleFilter('answerType', 'omitted')}
            />{' '}
            Skipped <span className='filterCheckmark' />
          </label>
        </div>
      </div>
    </div>
  );
};

export default FiltersPopUp;
